import {Pipe, PipeTransform} from '@angular/core';
import {PhoneNumberFormat, PhoneNumberUtil} from "google-libphonenumber";

@Pipe({
  name: 'phoneNumber',
})
export class PhoneNumberPipe implements PipeTransform {

  transform(value: unknown, ..._args: unknown[]): unknown {
    try {
      const phoneNumber = PhoneNumberUtil.getInstance().parse(value as string);
      return PhoneNumberUtil.getInstance().format(phoneNumber, PhoneNumberFormat.INTERNATIONAL);
    } catch (_e) {
      return value;
    }
  }

}
